/* eslint-disable no-unused-vars */
import { useParams } from 'react-router-dom';
import { useState, useEffect, useRef, useCallback } from 'react';
import { campaignReportsAPI } from 'services/campaignReports.service';
import { MenuItem, IconButton, FloatingPopUp, Loader } from 'components';
import { PauseAction, StartIcon, DotMenuIcon } from 'assets/icons';
import { showPolipop } from 'utils';

import * as S from './DotsMenu.styled';

const excludedArray = ['excluded', 1];
const includedArray = ['included', 0];

const statusField = {
  app: 'appStatus',
  creative: 'bn_status',
};

const uniqueField = {
  app: 'pba_number',
  creative: 'bn_bannerId',
};

export const DotsMenu = (props) => {
  const { env } = props;
  const currentUniqueField = uniqueField[env];
  const [updateCampaignAppStatus, resultUpdateCampaignApp] =
    campaignReportsAPI.useUpdateCampaignAppTargetingMutation();

  const [bulkActionsEnableDisableCreative, resultBulkActionsEnableDisableCreative] =
    campaignReportsAPI.useBulkActionsEnableDisableCreativeMutation();

  const result = { app: resultUpdateCampaignApp, creative: resultBulkActionsEnableDisableCreative };
  const currentResult = result[env];

  const { cmp_id } = useParams();

  const [isOpen, setIsOpen] = useState(false);

  const handleStatusChange = async (status) => {
    if (env === 'app') {
      const payload = {
        app: props.pba_number.toString(),
        cm_id: cmp_id,
      };
      payload.act = status;
      const res = await updateCampaignAppStatus(payload);
      console.log(res);
    }
    if (env === 'creative') {
      const selectAction = { add: 0, del: 1 };
      const payload = {
        bn_ids: props.bn_bannerId,
        cm_id: cmp_id,
        newBnStatus: selectAction[status],
      };

      const res = await bulkActionsEnableDisableCreative(payload);
      console.log(res);
    }
    setIsOpen(false);
    window.removeEventListener('click', closeOnClickOutside1, { once: false, capture: true });
  };

  function openClosePopUp() {
    let newIsOpen = !isOpen;
    setIsOpen(newIsOpen);
    if (newIsOpen) {
      window.addEventListener('click', closeOnClickOutside1, {
        once: false,
        capture: true,
      });
    } else {
      window.removeEventListener('click', closeOnClickOutside1, { once: false, capture: true });
    }
  }

  const closeOnClickOutside1 = useCallback((event) => {
    const clickToPopUp = event.target.closest(`.row-popup_${props[currentUniqueField]}`);
    const clickToMenuItem = event.target.closest('li');
    if (clickToPopUp === null && clickToMenuItem === null) {
      setIsOpen(false);
      window.removeEventListener('click', closeOnClickOutside1, { once: false, capture: true });
    }
  }, []);

  useEffect(() => {
    if (currentResult && (currentResult.isError || currentResult.isSuccess)) {
      showPolipop(currentResult);
    }
  }, [currentResult]);

  return (
    <div className={`row-popup_${props[currentUniqueField]}`}>
      {currentResult.isLoading && <Loader.Global delay={1000} />}
      <FloatingPopUp
        isOpen={isOpen}
        durationValue={50}
        offsetValue={10}
        closeAction={() => {}}
        defaultPlacement={FloatingPopUp.placements.bottom_start}
        //triggerStyle={{ zIndex: isOpen && 2100 }}
        //popUpWrapStyle={{ left: '0' }}
        popUpWrapStyle={{ zIndex: '4100' }}
        isOverlay={false}
        triggerComponent={
          <IconButton.SmallSize
            onClick={openClosePopUp}
            id='dot-menu-icon'
            ref={null}
            icon={DotMenuIcon}
            type={IconButton.btnTypes.tertiary}
            isPressed={isOpen}
          />
        }
        popUpComponent={
          <S.PopupWrap>
            {excludedArray.includes(props[statusField[env]]) && (
              <MenuItem
                height={40}
                icon={StartIcon}
                value='add'
                id='start_now'
                onClick={handleStatusChange}
                key='start_now'
                style={{ paddingRight: '22px' }}
              >
                Start Now
              </MenuItem>
            )}
            {includedArray.includes(props[statusField[env]]) && (
              <MenuItem
                height={40}
                icon={PauseAction}
                value='del'
                id='pause_now'
                onClick={handleStatusChange}
                key='pause_now'
                style={{ paddingRight: '22px' }}
              >
                Pause Now
              </MenuItem>
            )}
          </S.PopupWrap>
        }
      />
    </div>
  );
};
